import { render, staticRenderFns } from "./RestPasswordVue.vue?vue&type=template&id=66288d72&scoped=true"
import script from "./RestPasswordVue.vue?vue&type=script&lang=js"
export * from "./RestPasswordVue.vue?vue&type=script&lang=js"
import style0 from "./RestPasswordVue.vue?vue&type=style&index=0&id=66288d72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66288d72",
  null
  
)

export default component.exports